export const GET_TRANSACTION_CHARGES = gql`
    query GetTransactionCharges {
        transactionCharges {
            terminalCharges {
                locality {
                    intraRegional {
                        creditCardPercentage
                        debitCardPercentage
                    }
                    interRegional {
                        creditCardPercentage
                        creditCardPerItem
                        debitCardPercentage
                        debitCardPerItem
                    }
                }
                additionalCharges {
                    name
                    label
                    creditCardPercentage
                    debitCardPerItem
                }
            }
            onlineCharges {
                locality {
                    intraRegional {
                        creditCardPercentage
                        debitCardPercentage
                    }
                    interRegional {
                        creditCardPercentage
                        creditCardPerItem
                        debitCardPercentage
                        debitCardPerItem
                    }
                }
                additionalCharges {
                    name
                    label
                    creditCardPercentage
                    debitCardPerItem
                }
            }
        }
    }
`;
